import type { SVGProps } from 'react';

const SvgPlayerPlaybackSpeed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="m20.46 16.57-4.21-2.43c-.71-.41-1.61.1-1.61.93v4.86c0 .82.89 1.34 1.61.93l4.21-2.43c.71-.41.71-1.44 0-1.85z"
    />
    <path
      fill="currentcolor"
      d="M11.65 17H7.54c-.29 0-.56-.12-.75-.33a7.03 7.03 0 0 1-1.72-5.68c.43-3.09 3-5.59 6.11-5.94 2.03-.23 3.98.39 5.48 1.73A7 7 0 0 1 19 12c0 .24-.02.48-.04.71a1 1 0 1 0 1.99.21c.03-.3.05-.61.05-.92a9 9 0 0 0-3.01-6.71 9.03 9.03 0 0 0-7.04-2.23c-4 .45-7.31 3.67-7.86 7.65-.37 2.66.43 5.31 2.21 7.29.57.63 1.39 1 2.24 1h4.11c.55 0 1-.45 1-1s-.45-1-1-1"
    />
    <path
      fill="currentcolor"
      d="M15.71 9.71A.996.996 0 1 0 14.3 8.3l-1.78 1.78c-.16-.04-.33-.07-.51-.07-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2c0-.18-.03-.35-.07-.51l1.78-1.78z"
    />
  </svg>
);
export default SvgPlayerPlaybackSpeed;
